import React, { Suspense } from 'react';
import AppRouter from './routes/AppRoutes.js';
import { RecoilRoot } from 'recoil';
import '../node_modules/bootstrap/dist/css/bootstrap.css';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import useLocalStorageLeadTitleUpdater from './utils/useLocalStorageLeadTitleUpdater.ts';

function App(props) {
  useLocalStorageLeadTitleUpdater();
  const theme = createTheme({
    palette: {
      primary: {
        main: '#4962e5',
      },
      secondary: {
        main: '#0B6BCB',
      },
      text: {
        main: '#727475',
      },
    },
    components: {
      MuiLink: {
        styleOverrides: {
          root: {
            color: '#4962e5',
            textDecoration: 'none',
            '&:hover': {
              textDecoration: 'none',
            },
          },
        },
      },
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            a: {
              color: '#4962e5',
              textDecoration: 'none',
              '&:hover': {
                textDecoration: 'none',
              },
            },
          },
        },
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div className="App">
        <RecoilRoot>
          <Suspense fallback={true}>
            <AppRouter />
          </Suspense>
        </RecoilRoot>
      </div>
    </ThemeProvider>
  );
}

export default App;
